module.exports = __webpack_public_path__ + "static/media/hospital.a76ab75d.svg";